import { SystemBaseApi } from "./SystemBaseApi";
import {Methods} from "@newview/infrastructure";

/**
 * Api
 */
export class InstitutioninforrelationalBindingApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'core-institutioninforrelational-binding'
    }




    /**
     * 根据pid查询集合
     * @returns
     */
    public getListByPid(param) {
        return this.send({pid:param}, "getListByPid", Methods.GET)
    }



    /**
     * 绑定机构信息
     * @returns
     */
    public saveAll(param) {
        return this.send(param, "saveAll", Methods.POST)
    }


}
